import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ApproachPage = lazy(() => import('../pages/approach/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const TestimonialsPage = lazy(() => import('../pages/testimonials/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ConsultationPage = lazy(() => import('../pages/consultation/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/approach',
    element: <ApproachPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/testimonials',
    element: <TestimonialsPage />
  },
  {
    path: '/faq',
    element: <FAQPage />
  },
  {
    path: '/consultation',
    element: <ConsultationPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
